module.exports = __webpack_public_path__ + "static/media/home-icon.0f2b5fe4.svg";